module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-desktop@3x-661add9fe6b59d95ef203c5a353f79a2.jpg";